import React from 'react';
import styled from 'styled-components';

class ErrorBoundary extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true
        }
    }
    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <DivStyle>
                    <img src={'./static/images/wife.jpeg'} />
                    <p>网络连接错误，请检查网络</p>
                </DivStyle>
            );
        }
        return this.props.children;
    }
}

const DivStyle = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
        width: 1rem;
        height: auto;
    }
    p{
        color: #222;
        margin-top: 0.2rem;
    }
`;

export default ErrorBoundary;

